import React, { PureComponent } from 'react';
import {
  string,
  number,
  shape,
  oneOfType,
  element,
  func,
  bool,
} from 'prop-types';
import styled from 'styled-components';
import CopyToClipboard from 'react-copy-to-clipboard';

import LinkThin from 'crehana-icons/LinkThin';

import Text from 'crehana-ui/Text';

const Wrapper = styled.div`
  & span {
    font-size: 13px !important;
  }
  & > svg {
    margin-right: 7px;
  }
`;

const TooltipWrapper = styled.div`
  top: -72px;
  left: calc(50% - 35px);
  transition: opacity 0.8s ease;
`;

const ToolTipWrapper = styled.div`
  width: 70px;
  border-radius: 3px;
  background-color: #222;
  line-height: 16px;
  padding: 6px 0 7px;
  text-align: center;
  & > span {
    color: #fff !;
  }
`;

const Arrow = styled.div`
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #222;
  margin: auto;
`;

/** Component to copy any text to the clipboard */
class CopyButton extends PureComponent {
  state = {
    showToolTip: false,
  };

  handleOnCopy = (text, result) => {
    const { onAfterCopy } = this.props;

    if (result) {
      this.setState({ showToolTip: true }, () => {
        setTimeout(() => this.setState({ showToolTip: false }), 800);
        if (onAfterCopy) onAfterCopy(text);
      });
    }
  };

  render() {
    const { showToolTip } = this.state;
    const {
      textToCopy,
      messageAfterCopy,
      wrapperStyles,
      tooltipStyles,
      tooltipWrapperStyles,
      children,
      iconSize,
      test,
      hideArrow,
    } = this.props;

    return (
      <CopyToClipboard text={textToCopy} onCopy={this.handleOnCopy}>
        <Wrapper
          className="w-auto inline-block cursor-pointer relative"
          style={{ ...wrapperStyles, color: '#222222' }}
        >
          <LinkThin size={iconSize} />
          {children}
          <TooltipWrapper
            className={`${
              showToolTip ? 'opacity-1' : 'opacity-0'
            } block absolute`}
            style={{
              zIndex: showToolTip ? 9999 : -1,
              ...tooltipWrapperStyles,
            }}
          >
            <ToolTipWrapper style={tooltipStyles}>
              <Text color="white" test={test}>
                {messageAfterCopy}
              </Text>
            </ToolTipWrapper>
            {!hideArrow && (
              <Arrow
                style={{
                  borderTopColor: tooltipStyles.backgroundColor,
                }}
              />
            )}
          </TooltipWrapper>
        </Wrapper>
      </CopyToClipboard>
    );
  }
}

CopyButton.propTypes = {
  iconSize: number,
  textToCopy: string.isRequired,
  messageAfterCopy: string,
  onAfterCopy: func,
  wrapperStyles: shape({}),
  tooltipStyles: shape({}),
  tooltipWrapperStyles: shape({}),
  children: oneOfType([string, element]),
  /** Useful for snapshot testing. */
  test: bool,
  hideArrow: bool,
};

CopyButton.defaultProps = {
  onAfterCopy: undefined,
  children: '',
  messageAfterCopy: '¡Link Copiado!',
  wrapperStyles: {},
  tooltipStyles: {},
  tooltipWrapperStyles: {},
  iconSize: 12,
  test: false,
  hideArrow: false,
};

export default CopyButton;
